import {HostListener, OnInit} from '@angular/core';

export abstract class GeneralDragAndDropComponent {

  allDragElementIds: any[] = [];
  dropValues: number[] = [];
  currentDragElementId = null;
  currentBelowElement = null;

  currentCursorX: number;
  currentCursorY: number;
  currentBelowX: number;
  currentBelowY: number;
  shiftDragElementX: number;
  shiftDragElementY: number;

  lastScrollY = 0;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.currentDragElementId !== null) {
      this.moveAtCursor();
    } else {
      this.lastScrollY = window.scrollY;
    }
  }

  initValues() {
    this.dropValues = [];
    this.lastScrollY = 0;
  }

  @HostListener('touchstart', ['$event'])
  onTouchDown(event) {
    this.onMouseDown(event.touches[0]);
  }

  onMouseDown(event) {
    const id = event.target.attributes.id;

    if (id !== undefined) {
      this.currentDragElementId = id;

      this.shiftDragElementX = event.pageX - document.getElementById('container').offsetLeft - id.ownerElement.x;
      this.shiftDragElementY = event.pageY - document.getElementById('container').offsetTop - id.ownerElement.y;

      this.currentCursorX = event.pageX;
      this.currentCursorY = event.pageY;

      this.currentBelowX = event.clientX;
      this.currentBelowY = event.clientY;

      id.ownerElement.style.width = (this.getDragElementMaxSize() /
        (document.getElementById('container').clientWidth / document.getElementById('dragDropPart').clientWidth)).toString() + '%';
      id.ownerElement.style.position = 'absolute';
      id.ownerElement.style.zIndex = 10;

      this.moveAt(event.pageX, event.pageY);
    }
  }

  moveAt(pageX, pageY) {
    const xOffset = document.getElementById('container').offsetLeft;
    const yOffset = document.getElementById('container').offsetTop;
    this.currentDragElementId.ownerElement.style.left = pageX - xOffset - this.shiftDragElementX + 'px';
    this.currentDragElementId.ownerElement.style.top = pageY - yOffset - this.shiftDragElementY + 'px';

    this.currentCursorX = pageX;
    this.currentCursorY = pageY;
  }

  moveAtCursor() {
    const xOffset = document.getElementById('container').offsetLeft - window.scrollX;
    const yOffset = document.getElementById('container').offsetTop;
    this.currentDragElementId.ownerElement.style.left = this.currentCursorX - xOffset - this.shiftDragElementX + 'px';
    this.currentCursorY -= this.lastScrollY;
    this.lastScrollY = window.scrollY;
    this.currentCursorY = this.currentCursorY + this.lastScrollY;
    this.currentDragElementId.ownerElement.style.top = this.currentCursorY - yOffset - this.shiftDragElementY + 'px';

    this.currentDragElementId.ownerElement.hidden = true;
    const elemBelow = document.elementFromPoint(this.currentBelowX, this.currentBelowY);
    this.currentDragElementId.ownerElement.hidden = false;
    if (elemBelow !== null) {
      this.currentBelowElement = elemBelow.closest('.dragDropBox');
    }
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event) {
    this.onMouseMove(event.touches[0]);
  }

  onMouseMove(event) {
    if (this.currentDragElementId !== null) {
      this.moveAt(event.pageX, event.pageY);

      this.currentBelowX = event.clientX;
      this.currentBelowY = event.clientY;

      this.currentDragElementId.ownerElement.hidden = true;
      const elemBelow = document.elementFromPoint(event.clientX, event.clientY);
      this.currentDragElementId.ownerElement.hidden = false;
      if (elemBelow !== null) {
        this.currentBelowElement = elemBelow.closest('.dragDropBox');
      }
    }
  }

  @HostListener('touchend', ['$event'])
  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event) {
    if (this.currentDragElementId !== null) {
      if (this.currentBelowElement !== null) {
        for (let i = 0; i < this.allDragElementIds.length; i++) {
          if (this.currentDragElementId.value === this.allDragElementIds[i].toString()) {
            this.dropValues[parseInt(this.currentBelowElement.id, 10)] = i;
            break;
          }
        }
      }
      this.currentBelowElement = null;

      this.currentDragElementId.ownerElement.style.position = '';
      this.currentDragElementId.ownerElement.style.left = '';
      this.currentDragElementId.ownerElement.style.top = '';
      this.currentDragElementId.ownerElement.style.zIndex = 3;
      this.currentDragElementId.ownerElement.style.width = '';
      this.currentDragElementId = null;
    }
  }

  /**
   * The size of the drag element before onMouseDown.
   * We want to use this size during dragging (where position = absolute).
   * We do not want that the size of the element change if we drag the element.
   */
  abstract getDragElementMaxSize();

  /**
   * Set here the variable allDragElementIds
   * These are all the ids of the elements, which can be dragged.
   * The id that is used in the html file.
   */
  abstract setAllDragElementIds();

}
